export enum SelectionState {
    PAGE = 'PAGE',
    MANUAL = 'MANUAL',
    ALL = 'ALL'
}
